import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { basePath } from "./context/constants.js";
import { installToastGuards } from "./utils/toastSetup";

installToastGuards();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter basename={basePath}>
        <App />
    </BrowserRouter>
);

reportWebVitals();
